import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress
} from "@mui/material";
import { changeOfferStatus } from "../../../../services/pos/Tables";

const DeactivateOfferDialog = ({ offer, open, onClose, onSuccess }) => {
  const [loading, setLoading] = React.useState(false);

  const handleDeactivate = async () => {
    setLoading(true);
    try {
      await changeOfferStatus(offer.id);
      alert("✅ تم إيقاف العرض بنجاح");
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      alert("❌ " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>هل أنت متأكد؟</DialogTitle>
      <DialogContent>
        <DialogContentText>
          سيتم إيقاف العرض: <strong>{offer.name}</strong>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>إلغاء</Button>
        <Button onClick={handleDeactivate} color="error" disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "تأكيد الإيقاف"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeactivateOfferDialog;
